import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Spinner,
  Text,
} from "@chakra-ui/react";
import api from "api/api";
import { sortArrayBy } from "utils/filter-array-by";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect, useState } from "react";
import WhatsAppPortal from "../whatsapp-portal";
import {
  AddWhatsAppServerModal,
  openModalAddWhatsAppServer,
} from "./add-whatsapp-server-modal";

import { Toast } from "components/toast";

import { useSessoesWhatsAppWebSocket } from "./utils";
import { AddIcon } from "@chakra-ui/icons";
import { WhatsAppSessionListProps } from "./types";
import { InfoBalloon } from "components/info-balloon";
import { FiltrosWhatsAppSessions } from "./filtros-whatsapp-sessions";
import { FiltersWhatsAppSessions } from "./filtros-whatsapp-sessions/types";
import apiCarteira from "api/api-carteira";
import { ModalHistoricoSessaoWpp } from "../modal-historico";

// Search será por nome telefone ou id

export function GridServers() {
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<FiltersWhatsAppSessions>({
    text: "",
    onlyDisconnected: false,
  });
  const [serviceData, setServiceData] = useState<any>({});
  const { user } = useApplicationContext();
  const permitedSeeAllCustomers = [
    "SUPER",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_GERENTE_ESTRATEGICO",
  ].includes(user.userData.type!);
  const {
    sendJsonMessage,
    servers,
    setIsConnect,
    setServers,
    reconnectWs,
    sessionsData,
  } = useSessoesWhatsAppWebSocket();

  const filteredServers = servers
    .filter((server) => {
      if (filters.onlyDisconnected) {
        if (server.status === "CONNECTED") return false;
      }
      return true;
    })
    .filter((server) => {
      const textSearch = filters.text;
      const searchNumbers = filters.text?.replace(/\D/g, "");
      let result = false;

      if (!textSearch) return true;

      if (server.nome) {
        result =
          result ||
          server.nome.toLowerCase().includes(textSearch.toLowerCase()!);
      }
      if (permitedSeeAllCustomers && server.customerCodigoNova) {
        result =
          result ||
          server.customerCodigoNova
            .toLowerCase()
            .includes(textSearch.toLowerCase()!);
      }
      if (permitedSeeAllCustomers && server.customerName) {
        result =
          result ||
          server.customerName.toLowerCase().includes(textSearch.toLowerCase()!);
      }
      if (server.whatsAppNumber && searchNumbers && searchNumbers.length >= 3) {
        result =
          result ||
          server.whatsAppNumber.replace(/\D/g, "").includes(searchNumbers);
      }

      return result;
    });

  const getServices = async () => {
    if (
      ["SUPER", "COMERCIAL", "PARCEIRO_MASTER"].includes(user.userData.type!)
    ) {
      try {
        const { data } = await apiCarteira.get(
          `/services?customer_id=${user.userData.customerId}`
        );
        setServiceData(data);
      } catch (e) {}
    }
  };

  const getServers = async () => {
    setLoading(true);
    setIsConnect(false);
    try {
      const [respSessions] = await Promise.all([
        api.get<WhatsAppSessionListProps[]>(`/whatsapp-sessions?all=true`),
        getServices(),
      ]);
      setServers(respSessions.data);
    } catch (e) {
      Toast({
        title: "Erro ao carregar sessões whatsapp!",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServers();
  }, []);

  useEffect(() => {
    if (servers.length) setIsConnect(true);
  }, [servers]);

  const servidores: string[] = [
    ...new Set(
      sortArrayBy(filteredServers, "customerCodigoNova", "ASC").map(
        ({ customerName }) => customerName
      )
    ),
  ];

  const filteredDisparoCampanhaServers = filteredServers.filter(
    ({ type }) => type === "DISPARO_CAMPANHA"
  );

  const filteredAtendimentoServers = filteredServers.filter(
    ({ type }) => type === "ATENDIMENTO"
  );

  return (
    <>
      <Flex justifyContent="space-between" mb="30px">
        <Text fontSize="25" fontWeight="bold">
          Sessões WhatsApp
        </Text>

        <Button
          disabled={loading}
          onClick={() => openModalAddWhatsAppServer()}
          leftIcon={<AddIcon />}
        >
          Criar Sessão
        </Button>
      </Flex>

      <FiltrosWhatsAppSessions filters={filters} setFilters={setFilters} />

      {loading ? (
        <Center w="100%" h="100%">
          <Spinner />
        </Center>
      ) : (
        <Box>
          <InfoBalloon w="50%" minW="300px" mb="20px">
            <Box>
              As <b>Sessões de Atendimento</b> destinam-se exclusivamente ao{" "}
              <b>atendimento ao cliente.</b> Não é permitido selecionar uma{" "}
              <b>Sessão de Atendimento</b> para o envio de mensagens em
              campanhas, pois estão mais suscetíveis a <b>banimentos</b> ao
              serem usadas para essa finalidade.
            </Box>
          </InfoBalloon>

          {user.userData.type === "SUPER" ||
          user.userData.type === "PARCEIRO_GERENTE_VAREJO" ||
          user.userData.type === "PARCEIRO_GERENTE_ESTRATEGICO"
            ? servidores.map((customer, index) => {
                const isLast = index + 1 === servidores.length;
                const customerFilteredServers = filteredServers.filter(
                  (crr) => crr.customerName === customer
                );

                const customerCode =
                  customerFilteredServers[0]?.customerCodigoNova;

                if (!customerFilteredServers.length) {
                  return null;
                }

                return (
                  <Box
                    w="100%"
                    key={`${customer}-${index}-session`}
                    mb={isLast ? undefined : "15px"}
                  >
                    <Text fontSize="20px">
                      {customerCode
                        ? `${customerCode} - ${customer}`
                        : customer}
                    </Text>
                    <hr style={{ marginBottom: "10px", marginTop: "10px" }} />

                    <Grid gap="25px" templateColumns="1fr 1fr 1fr" w="100%">
                      {customerFilteredServers.map((item) => {
                        return (
                          <WhatsAppPortal
                            key={item.id}
                            setServers={setServers}
                            sendJsonMessage={sendJsonMessage}
                            reconnectWs={reconnectWs}
                            sessionsData={sessionsData}
                            serviceData={serviceData}
                            {...item}
                          />
                        );
                      })}
                    </Grid>
                  </Box>
                );
              })
            : null}

          {!(
            user.userData.type === "SUPER" ||
            user.userData.type === "PARCEIRO_GERENTE_VAREJO" ||
            user.userData.type === "PARCEIRO_GERENTE_ESTRATEGICO"
          ) ? (
            <>
              {!!filteredDisparoCampanhaServers.length && (
                <>
                  <Text fontSize="20px" fontWeight="semibold">
                    Sessões para Disparo de Campanha
                  </Text>

                  <Box
                    as="hr"
                    bg="var(--chakra-colors-custom-gray)"
                    my="10px"
                    h="1px"
                  />
                </>
              )}
              <Box w="100%" mb={"15px"}>
                <Grid gap="25px" templateColumns="1fr 1fr 1fr" w="100%">
                  {filteredDisparoCampanhaServers.map((customer, index) => {
                    return (
                      <WhatsAppPortal
                        key={customer.id}
                        setServers={setServers}
                        sendJsonMessage={sendJsonMessage}
                        reconnectWs={reconnectWs}
                        sessionsData={sessionsData}
                        serviceData={serviceData}
                        {...customer}
                      />
                    );
                  })}
                </Grid>
              </Box>
              {!!filteredAtendimentoServers.length && (
                <>
                  <Text
                    fontSize="20px"
                    fontWeight="semibold"
                    mt={filteredAtendimentoServers.length ? "30px" : ""}
                  >
                    Sessões para Atendimento
                  </Text>
                  <Box
                    as="hr"
                    bg="var(--chakra-colors-custom-gray)"
                    my="10px"
                    h="1px"
                  />
                </>
              )}
              <Box w="100%">
                <Grid gap="25px" templateColumns="1fr 1fr 1fr" w="100%">
                  {filteredAtendimentoServers.map((customer, index) => {
                    return (
                      <WhatsAppPortal
                        key={customer.id}
                        setServers={setServers}
                        sendJsonMessage={sendJsonMessage}
                        reconnectWs={reconnectWs}
                        sessionsData={sessionsData}
                        serviceData={serviceData}
                        {...customer}
                      />
                    );
                  })}
                </Grid>
              </Box>
            </>
          ) : null}
        </Box>
      )}

      <AddWhatsAppServerModal
        setServers={setServers}
        sendJsonMessage={sendJsonMessage}
        servers={servers}
        reconnectWs={reconnectWs}
      />
      <ModalHistoricoSessaoWpp />
    </>
  );
}
